//Justin Windle:
//https://codepen.io/soulwire/pen/mErPAK

// ——————————————————————————————————————————————————
// TextScramble
// ——————————————————————————————————————————————————

export class TextScramble {
	private speed;
	private el;
	private chars;
	private queue;
	private resolve;
	private frameRequest;
	private frame;
	private killed = false;

	constructor(el, speed) {
		this.speed = 10;
		this.el = el;
		this.chars = '!<>-_\\/[]{}—=+*^?#________';
		this.update = this.update.bind(this);

		if (speed) {
			this.speed = speed;
		}
	}

	public setSpeed(value: number) {
		this.speed = value;
	}

	kill() {
		this.killed = true;
	}

	blank() {
		this.el.innerText = '';
	}

	setText(newText) {
		const oldText = this.el.innerText;
		const length = Math.max(oldText.length, newText.length);
		const promise = new Promise((resolve) => (this.resolve = resolve));
		this.queue = [];
		for (let i = 0; i < length; i++) {
			const from = oldText[i] || '';
			const to = newText[i] || '';
			const start = Math.floor(Math.random() * this.speed);
			const end = start + Math.floor(Math.random() * this.speed);
			this.queue.push({ from, to, start, end });
		}
		cancelAnimationFrame(this.frameRequest);
		this.frame = 0;
		this.update();
		return promise;
	}
	update() {
		if (this.killed) {
			return;
		}

		let output = '';
		let complete = 0;
		for (let i = 0, n = this.queue.length; i < n; i++) {
			const { from, to, start, end } = this.queue[i];
			let { char } = this.queue[i];
			if (this.frame >= end) {
				complete++;
				output += to;
			} else if (this.frame >= start) {
				if (!char || Math.random() < 0.28) {
					char = this.randomChar();
					this.queue[i].char = char;
				}
				output += `<span class="dud">${char}</span>`;
			} else {
				output += from;
			}
		}
		this.el.innerHTML = output;
		if (complete === this.queue.length) {
			this.resolve();
		} else {
			this.frameRequest = requestAnimationFrame(this.update);
			this.frame++;
		}
	}
	randomChar() {
		return this.chars[Math.floor(Math.random() * this.chars.length)];
	}
}
